import { v4 as uuidv4 } from 'uuid'
import { BaseOfflineStore } from './base.store'
import { SyncConflict } from '../types/database.types'

export class ConflictsOfflineStore extends BaseOfflineStore<SyncConflict> {
    constructor() {
        super('conflicts')
    }

    async addConflict(conflictData: Omit<SyncConflict, '_id' | '_syncStatus' | '_lastModified' | '_createdAt' | '_offlineId' | 'createdAt'>): Promise<SyncConflict> {
        const now = Date.now()
        const conflict: SyncConflict = {
            ...conflictData,
            _id: uuidv4(),
            _offlineId: uuidv4(),
            _syncStatus: 'pending',
            _lastModified: now,
            _createdAt: now,
            createdAt: now
        }

        return this.add(conflict)
    }

    async getConflictsByEntityType(entityType: string): Promise<SyncConflict[]> {
        const conflicts = await this.getAll()
        return conflicts.filter(conflict => conflict.entityType === entityType)
    }

    async getConflictsByType(conflictType: string): Promise<SyncConflict[]> {
        const conflicts = await this.getAll()
        return conflicts.filter(conflict => conflict.conflictType === conflictType)
    }

    async resolveConflict(conflictId: string): Promise<void> {
        await this.delete(conflictId)
    }

    async clearAllConflicts(): Promise<void> {
        const conflicts = await this.getAll()
        for (const conflict of conflicts) {
            await this.delete(conflict._id)
        }
    }
}

// Create a singleton instance
export const conflictsOfflineStore = new ConflictsOfflineStore() 